import { Injectable, inject, signal, effect } from '@angular/core'
import { MatDialog, MatDialogRef } from '@angular/material/dialog'
import { firstValueFrom } from 'rxjs'

import { TermsOfServiceModalComponent } from '../components/terms-of-service-modal/terms-of-service-modal.component'
import { AuthService } from '../../auth/services/auth.service'

@Injectable({
  providedIn: 'root',
})
export class TermsOfServiceService {
  private dialog = inject(MatDialog)
  private authService = inject(AuthService)

  private modalRef: MatDialogRef<TermsOfServiceModalComponent> | null = null
  readonly isModalOpen = signal(false)

  constructor () {
    effect(() => {
      const user = this.authService.currentUser()
      this.handleUserChange(user)
    })
  }

  private handleUserChange (user: any): void {
    if (user && !user.terms_accepted && !this.modalRef) {
      this.showTermsModal()
    } else if (user && user.terms_accepted && this.modalRef) {
      this.closeTermsModal()
    }
  }

  private async showTermsModal (): Promise<void> {
    if (this.modalRef) return

    this.modalRef = this.dialog.open(TermsOfServiceModalComponent, {
      width: '600px',
      maxWidth: '90vw',
      maxHeight: '90vh',
      disableClose: true,
      hasBackdrop: true,
      backdropClass: 'terms-modal-backdrop',
      panelClass: 'terms-modal-panel',
    })

    this.isModalOpen.set(true)

    await firstValueFrom(this.modalRef.afterClosed())
    this.modalRef = null
    this.isModalOpen.set(false)
  }

  private closeTermsModal (): void {
    if (this.modalRef) {
      this.modalRef.close(true)
      this.modalRef = null
      this.isModalOpen.set(false)
    }
  }

  public checkTermsAcceptance (): void {
    const user = this.authService.currentUser()
    if (user && !user.terms_accepted) {
      this.showTermsModal()
    }
  }

  public forceCloseModal (): void {
    this.closeTermsModal()
  }
}
